import React from 'react';
import XLogo from 'assets/images/lBlack.png';

interface SocialLogoProps {
  style?: React.CSSProperties;
}

const TwitterWhiteLogo: React.FC<SocialLogoProps> = ({ style }) => (
  <div style={{
    backgroundColor: 'black',
    width: '16px',
    height: '16px',
    borderRadius: '3px',
    padding: '3px',
    display: 'flex',
    alignItems: 'center',
    ...style,
  }}>
    <img className="x-logo" src={XLogo} alt="X" style={{
      filter: 'invert(1)',
      width: '10px',
      height: '10px',
    }} />
  </div>
)

export default TwitterWhiteLogo;
